import { HOST, } from "common/constants";
import React, { useState, useEffect } from "react";
import {
  CircularProgress,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BatkenSvg from "assets/svg/BatkenSvg";
import ChuySvg from "assets/svg/ChuySvg";
import DjalalSvg from "assets/svg/DjalalSvg";
import Naryn from "assets/svg/Naryn";
import OshSvg from "assets/svg/OshSvg";
import TalasSvg from "assets/svg/TalasSvg";
import YssykColSvg from "assets/svg/YssykColSvg";

import too from "../../assets/images/too.jpg";
import styles from "./Organs.module.scss";

const Organs = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isHomeMobile = isMobile && location.pathname === "/";

  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRegions = async () => {
      try {
        const response = await axios.get(
          `${HOST}/api/v1/resolutions/regions/`
        );
        setRegions(response.data);
      } catch (err) {
        console.error("Ошибка загрузки регионов:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchRegions();
  }, []);

  const getRegionData = (searchTitle) =>
    regions.find((r) =>
      r.title_ru.toLowerCase().includes(searchTitle.toLowerCase())
    );

  const handleTextClick = (searchTitle) => {
    const region = getRegionData(searchTitle);
    if (region) navigate(`/organs/${region.slug}`);
  };

  const getLocalizedTitle = (searchTitle) => {
    const region = getRegionData(searchTitle);
    if (!region) return searchTitle;
    return i18n.language === "ky" ? region.title_ky : region.title_ru;
  };

  

  const textCoordinates = {
    Баткен: { x: 140, y: 490, searchKey: "Баткен" },
    Чуй: { x: 550, y: 100, searchKey: "Чуй" },
    "Джалал-Абад": { x: 380, y: 230, searchKey: "Джалал-Абад" },
    Нарын: { x: 660, y: 250, searchKey: "Нарын" },
    Ош: { x: 440, y: 450, searchKey: "Ошская" },
    Талас: { x: 280, y: 110, searchKey: "Талас" },
    "Иссык-Куль": { x: 930, y: 160, searchKey: "Иссык-Куль" },
  };

  const cityLabels = [
    {
      label: i18n.language === "ky" ? "Бишкек шаары" : "город Бишкек",
      slug: "gorod-bishkek",
      x: 450,
      y: 40,
    },
    {
      label: i18n.language === "ky" ? "Ош шаары" : "город Ош",
      slug: "gorod-osh",
      x: 400,
      y: 390,
    },
  ];

  const renderRegion = (searchTitle, SvgComponent) => {
    const coords = textCoordinates[searchTitle];
    const title = getLocalizedTitle(coords?.searchKey || searchTitle);

    return (
      <g
        key={searchTitle}
        className={`${styles.regionGroup} ${isMobile ? styles.mobile : ""}`}
      >
        <SvgComponent />

        {coords && (
          <text
            x={coords.x}
            y={coords.y}
            // style={labelStyle}
            className={styles.labelStyle}
            onClick={() => handleTextClick(coords.searchKey)}
          >
            {title}
          </text>
        )}
      </g>
    );
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div className={styles.wrapper} style={{ "--bg-image": `url(${too})` }}>
      <div className={styles.overlay}>
        <div className={styles.container}>
          <h4
            className={`${styles.title} ${isHomeMobile ? styles.mobile : ""}`}
          >
            {t("OrgansRegionList") || "Список областей"}
          </h4>

          <div className={styles.svgBox}>
            <svg
              viewBox="0 0 1170 575"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              {renderRegion("Баткен", BatkenSvg)}
              {renderRegion("Чуй", ChuySvg)}
              {renderRegion("Джалал-Абад", DjalalSvg)}
              {renderRegion("Нарын", Naryn)}
              {renderRegion("Ош", OshSvg)}
              {renderRegion("Талас", TalasSvg)}
              {renderRegion("Иссык-Куль", YssykColSvg)}

              {cityLabels.map(({ label, slug, x, y }) => (
                <text
                  key={slug}
                  x={x}
                  y={y}
                  // style={{ ...labelStyle, fill: "black", fontSize: "18px" }}
                  className={styles.cityLabels}
                  onClick={() => navigate(`/organs/${slug}`)}
                >
                  {label}
                </text>
              ))}
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Organs;
